import { useState, useEffect } from 'react'
import { ANIMATION, APP_CONFIG } from '../../../constants'
import './Landing.css'

interface LandingProps {
  onAnimationComplete: () => void
  showHeader: boolean
}

const Landing = ({ onAnimationComplete, showHeader }: LandingProps) => {
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [showFirstName, setShowFirstName] = useState(true)
  const [showLastName, setShowLastName] = useState(false)
  const [showCursor, setShowCursor] = useState(true)

  const fullFirstName = APP_CONFIG.AUTHOR.split(' ')[0].trim() // 'Ertugrul'
  const fullLastName = APP_CONFIG.AUTHOR.split(' ')[1].trim() // 'Kücükkaya'

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>

    if (showFirstName && firstName.length < fullFirstName.length) {
      timeoutId = setTimeout(() => {
        setFirstName(fullFirstName.slice(0, firstName.length + 1))
      }, ANIMATION.TYPING_SPEED)
    } else if (showFirstName && firstName.length === fullFirstName.length) {
      // First name complete, start last name after a brief pause
      timeoutId = setTimeout(() => {
        setShowFirstName(false)
        setShowLastName(true)
      }, ANIMATION.PAUSE_BETWEEN_NAMES)
    } else if (showLastName && lastName.length < fullLastName.length) {
      timeoutId = setTimeout(() => {
        setLastName(fullLastName.slice(0, lastName.length + 1))
      }, ANIMATION.TYPING_SPEED)
    } else if (showLastName && lastName.length === fullLastName.length) {
      // Animation complete, hide cursor and wait 1 second then call onAnimationComplete
      timeoutId = setTimeout(() => {
        setShowCursor(false)
        setTimeout(() => {
          onAnimationComplete()
        }, ANIMATION.HEADER_SHOW_DELAY)
      }, ANIMATION.CURSOR_HIDE_DELAY)
    }

    return () => clearTimeout(timeoutId)
  }, [firstName, lastName, showFirstName, showLastName, fullFirstName, fullLastName, onAnimationComplete])

  return (
    <div id="home" className={`landing ${showHeader ? 'with-header' : ''}`}>
      <div className="landing-content">
        <div className="name-container">
          <h1 className="first-name">
            {firstName}
            {showFirstName && showCursor && <span className="cursor">|</span>}
          </h1>
          {showLastName && (
            <h2 className="last-name">
              {lastName}
              {showCursor && <span className="cursor">|</span>}
            </h2>
          )}
        </div>
      </div>
    </div>
  )
}

export default Landing
